import { THEME } from "../../util/LookupConst";
import { LoginUserDetails, Product } from "../../util/Utils";
import { ViewQuilt as ViewQuiltIcon } from "@mui/icons-material";

const FranchiseeLoginMenuList: any = {
  DASHBOARD: {
    name: "Dashboard",
    icon: <ViewQuiltIcon />,
    subMenu: [],
    path: "/dashboard",
  },
  MASTER: [
    { name: "Batch", path: "/batch-list" },
    { name: "Course Instructor", path: "/course-instructor" },
    { name: "User Master", path: "/user-master" },
  ],
  STUDENT: [
    { name: "Leads", path: "/student-lead-management" },
    { name: "Registration / Master", path: "/student-master" },
    { name: "Invoice", path: "/student-invoice" },
    { name: "Payment Gateway ", path: "/payments-gateway" },
    { name: "Certificate", path: "/certificate-booking-printing" },
    { name: "Attendance", path: "/student-attendance" },
    Product.ProductCode() === THEME.SA
      ? { name: "AGC/Prodigy Student Registration" }
      : null,
  ],
  STUDENT_US: [
    { name: "Leads", path: "/student-lead-management" },
    { name: "Registration / Master", path: "/student-master" },
    { name: "Invoice", path: "/student-invoice" },
    { name: "Certificate", path: "/certificate-booking-printing" },
    { name: "Attendance", path: "/student-attendance" },
  ],
  PURCHASE: [
    { name: "Order", path: "/order" },
    { name: "Purchase Return", path: "/purchase-return" },
    { name: "Kit Outstanding", path: "/outstanding" },
    { name: "Payment Summary", path: "/payment-summary" },
    {
      name: "Redeem Point Order",
      path: "/student-redeem-point-order",
    },
    {
      name: "Dispatch Redeemed Product",
      path: "/dispatch-redeemed-product",
    },
  ],
  REPORTS: [{ name: "Manage Reports", path: "/manage-reports" }],
  NOTIFICATION: [
    { name: "Send Email or SMS", path: "/send-email-sms" },
    { name: "Templates", path: "/template" },
    { name: "Sent History", path: "/sent-history" },
  ],
};

export default FranchiseeLoginMenuList;
